/**
 * @hidden
 */
var onDownPreventDefault = {
  onMouseDown: function onMouseDown(e) {
    return e.preventDefault();
  },
  onPointerDown: function onPointerDown(e) {
    return e.preventDefault();
  }
};
/**
 * @hidden
 */
var userSelectNone = {
  userSelect: 'none'
};
/**
 * @hidden
 */
var formatString = function formatString(input) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  args.forEach(function (value, index) {
    input = input.replace('{' + index + '}', String(value));
  });
  return input;
};
export { onDownPreventDefault, formatString, userSelectNone };